/* Towlivesmatter add-on offers (product page + cart drawer).
   Markup: snippets/tlm-offer-pdp.liquid, snippets/tlm-offer-cart.liquid.
   Rules: Theme settings > Upsell offers (TLM).

   - Every cart write goes through one queue, so fast repeated clicks and the
     two placements never race each other.
   - After /cart/add.js the cart is re-read and compared with the snapshot taken
     before the request; the message reports exactly what was and wasn't added.
   - The drawer is refreshed through the theme's own CartDrawer
     (window.TLMCartDrawer, exposed in assets/retina.js) so its quantity and
     remove controls keep working. Without it we fall back to the cart page.
   - Offer adds carry a hidden line property _tlm_offer = "<placement>:<rule id>"
     (not shown to customers) so orders can be attributed to an offer.
   - Analytics: Shopify.analytics.publish custom events tlm_offer_viewed,
     tlm_offer_interacted, tlm_offer_added (read them in a custom pixel). */
(() => {
  if (window.TLMOffers) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || `${root}cart`;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------------- money ---------------- */
  const moneyFormat = (window.PXUTheme && window.PXUTheme.currency && (window.PXUTheme.currency.money_format_no_currency || window.PXUTheme.currency.money_format)) || '${{amount}}';
  function formatMoney(cents) {
    const n = Number(cents) || 0;
    const fmt = (amount, decimals, thou, dec) => {
      const fixed = (amount / 100).toFixed(decimals).split('.');
      const whole = fixed[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thou}`);
      return fixed[1] ? whole + dec + fixed[1] : whole;
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(n, 2, ' ', ',');
        default: return fmt(n, 2, ',', '.');
      }
    });
  }

  /* ---------------- analytics ---------------- */
  function publish(name, data) {
    try {
      const a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') {
        a.publish(name, Object.assign({
          currency: (window.Shopify.currency && window.Shopify.currency.active) || null,
          country: window.Shopify.country || null,
        }, data));
      }
    } catch (e) { /* never block shopping on analytics */ }
  }
  const rowData = (row) => ({
    offer_id: row.dataset.rule,
    product_id: Number(row.dataset.productId),
    variant_id: Number(selectedVariant(row)) || null,
  });

  /* ---------------- cart queue ---------------- */
  let chain = Promise.resolve();
  const enqueue = (fn) => { const run = chain.then(fn, fn); chain = run.catch(() => {}); return run; };

  async function getCart() {
    const r = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok) throw new Error('cart');
    return r.json();
  }
  const qtyOf = (cart, id) => cart.items.filter((l) => l.variant_id === Number(id)).reduce((s, l) => s + l.quantity, 0);

  /** Adds items ({id, rule, title}) in one request and reconciles with the real cart. */
  function addItems(items, placement) {
    return enqueue(async () => {
      let before = null;
      try { before = await getCart(); } catch (e) { /* reconciled below if possible */ }
      let error = null;
      try {
        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items.map((i) => ({ id: Number(i.id), quantity: 1, properties: { _tlm_offer: `${placement}:${i.rule}` } })) }),
        });
        if (!res.ok) {
          const body = await res.json().catch(() => ({}));
          error = body.description || body.message || 'This item could not be added.';
        }
      } catch (e) {
        error = 'Connection problem. Please check your connection and try again.';
      }
      let after = null;
      try { after = await getCart(); } catch (e) { /* unknown state */ }
      const added = []; const failed = [];
      if (before && after) {
        items.forEach((i) => ((qtyOf(after, i.id) > qtyOf(before, i.id)) ? added : failed).push(i));
      } else {
        (error ? failed : added).push(...items);
      }
      if (added.length) publish('tlm_offer_added', { placement, items: added.map((i) => ({ offer_id: i.rule, product_id: i.productId, variant_id: Number(i.id) })) });
      return { added, failed, error: failed.length ? (error || 'Not added.') : null, cart: after };
    });
  }

  /* ---------------- theme drawer bridge ---------------- */
  const drawerEl = () => $('[data-cart-drawer]');
  const drawerOpen = () => !!$('[data-cart-overlay].active');
  function scrollBox() {
    const d = drawerEl();
    if (!d) return null;
    return [d, $('.cart-drawer__form', d), $('.cart-drawer__items', d)].find((el) => el && el.scrollHeight > el.clientHeight + 1) || d;
  }
  /** Reload the theme drawer; resolves once the new markup is in place. */
  function refreshDrawer(open, trigger) {
    const cd = window.TLMCartDrawer; const d = drawerEl();
    if (!cd || typeof cd.loadDrawer !== 'function' || !d) return Promise.resolve(false);
    return new Promise((resolve) => {
      const done = () => { mo.disconnect(); clearTimeout(t); resolve(true); };
      const mo = new MutationObserver(() => { if ($('.cart-drawer__header', d)) done(); });
      mo.observe(d, { childList: true });
      const t = setTimeout(done, 6000);
      if (trigger) cd.trigger = trigger; // focus returns here when the drawer closes
      cd.loadDrawer(open);
    });
  }

  /* ---------------- shared row helpers ---------------- */
  const selectedVariant = (row) => row.dataset.variantId || ($('[data-offer-variant]', row) || {}).value || '';
  function rowPrice(row) {
    if (row.dataset.price) return Number(row.dataset.price);
    const sel = $('[data-offer-variant]', row);
    const opt = sel && sel.selectedOptions[0];
    return opt && opt.dataset.price ? Number(opt.dataset.price) : null;
  }
  function setRowError(row, msg) {
    const err = $('[data-offer-err]', row); const sel = $('[data-offer-variant]', row);
    if (!err) return;
    err.textContent = msg || '';
    err.hidden = !msg;
    if (sel) sel.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }
  function syncRowPrice(row) {
    const p = rowPrice(row); const el = $('[data-offer-price]', row);
    if (p != null && el && !row.dataset.price) el.textContent = formatMoney(p);
  }
  const names = (list) => list.map((i) => i.title).join(', ');

  /* ---------------- product page module ---------------- */
  function initPdp(mod) {
    const rows = () => $$('[data-offer-row]', mod).filter((r) => !r.hidden);
    const btn = $('[data-offer-add]', mod); const label = $('[data-offer-add-label]', mod); const status = $('[data-offer-status]', mod);
    let busy = false;

    function summary() {
      const picked = rows().filter((r) => $('[data-offer-check]', r).checked);
      if (busy) return;
      if (!picked.length) { label.textContent = 'Tick an item to add it'; btn.disabled = true; return; }
      const known = picked.every((r) => rowPrice(r) != null);
      const total = picked.reduce((s, r) => s + (rowPrice(r) || 0), 0);
      const count = `${picked.length} item${picked.length > 1 ? 's' : ''}`;
      label.textContent = known ? `Add ${count} to cart · ${formatMoney(total)}` : `Add ${count} to cart`;
      btn.disabled = false;
    }

    // Products split across shipping profiles: only while a General-profile variant is selected.
    const gen = mod.dataset.genVariants || '';
    const idInput = document.querySelector('#tlm-pdp-form [name="id"]');
    const variantOk = () => !gen || !idInput || gen.includes(`,${idInput.value},`);
    const syncVisible = () => { mod.hidden = rows().length === 0 || !variantOk(); };
    if (gen) {
      const later = () => setTimeout(syncVisible, 60);
      document.addEventListener('change', (e) => { if (e.target.closest('.tlm-pd') && !e.target.closest('[data-tlm-offer]')) later(); });
      document.addEventListener('click', (e) => { if (e.target.closest('.tlm-pd label') && !e.target.closest('[data-tlm-offer]')) later(); });
    }

    async function hideInCart(cart) {
      try {
        const c = cart || await getCart();
        const ids = new Set(c.items.map((l) => l.product_id));
        $$('[data-offer-row]', mod).forEach((r) => {
          const inCart = ids.has(Number(r.dataset.productId));
          r.hidden = inCart;
          if (inCart) $('[data-offer-check]', r).checked = false;
        });
      } catch (e) { /* keep server-rendered state */ }
      syncVisible();
      summary();
    }

    mod.addEventListener('change', (e) => {
      const row = e.target.closest('[data-offer-row]');
      if (!row) return;
      if (e.target.matches('[data-offer-variant]')) {
        if (e.target.value) { $('[data-offer-check]', row).checked = true; setRowError(row, ''); }
        syncRowPrice(row);
      }
      if (e.target.matches('[data-offer-check]') && !e.target.checked) setRowError(row, '');
      publish('tlm_offer_interacted', Object.assign({ placement: 'product', action: e.target.matches('[data-offer-check]') ? (e.target.checked ? 'select' : 'deselect') : 'variant' }, rowData(row)));
      status.textContent = '';
      summary();
    });

    btn.addEventListener('click', async () => {
      if (busy) return;
      const picked = rows().filter((r) => $('[data-offer-check]', r).checked);
      if (!picked.length) return;
      // Every required option must be chosen; never pick one for the customer.
      const missing = picked.filter((r) => !selectedVariant(r));
      picked.forEach((r) => setRowError(r, ''));
      if (missing.length) {
        missing.forEach((r) => {
          const sel = $('[data-offer-variant]', r);
          const name = (sel && sel.options[0].textContent.replace(/^Choose\s+/i, '')) || 'an option';
          setRowError(r, `Choose ${name} first.`);
        });
        $('[data-offer-variant]', missing[0]).focus();
        status.textContent = '';
        return;
      }
      busy = true; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); label.textContent = 'Adding…';
      status.textContent = '';
      const items = picked.map((r) => ({ id: selectedVariant(r), rule: r.dataset.rule, title: r.dataset.title, productId: Number(r.dataset.productId) }));
      const res = await addItems(items, 'product');
      busy = false; btn.removeAttribute('aria-busy');
      if (res.added.length && !res.failed.length) {
        status.textContent = `Added to cart: ${names(res.added)}.`;
        status.className = 'tlm-offer__status is-ok';
      } else if (res.added.length) {
        status.textContent = `Added: ${names(res.added)}. Not added: ${names(res.failed)}. ${res.error}`;
        status.className = 'tlm-offer__status is-warn';
      } else {
        status.textContent = `Not added: ${names(res.failed)}. ${res.error}`;
        status.className = 'tlm-offer__status is-error';
      }
      if (res.cart) await hideInCart(res.cart); else summary();
      if (res.added.length) {
        const ok = await refreshDrawer(true, btn);
        if (!ok && !res.failed.length) window.location.href = cartUrl;
      }
    });

    syncVisible();
    hideInCart();
    // Keep in step with the drawer (removals there bring suggestions back).
    const d = drawerEl();
    if (d) new MutationObserver(() => { if (!busy) hideInCart(); }).observe(d, { childList: true });
    seen(mod, 'product');
  }

  /* ---------------- cart drawer module ---------------- */
  let flash = null; // message to show after the drawer re-renders
  let drawerBusy = false;

  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-tlm-offer="cart"] [data-offer-variant]');
    if (!sel) return;
    const row = sel.closest('[data-offer-row]');
    setRowError(row, '');
    syncRowPrice(row);
    publish('tlm_offer_interacted', Object.assign({ placement: 'cart', action: 'variant' }, rowData(row)));
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-tlm-offer="cart"] [data-offer-add-one]');
    if (!btn) return;
    e.preventDefault();
    if (drawerBusy) return;
    const row = btn.closest('[data-offer-row]');
    const id = selectedVariant(row);
    if (!id) {
      const sel = $('[data-offer-variant]', row);
      setRowError(row, `Choose ${sel ? sel.options[0].textContent.replace(/^Choose\s+/i, '') : 'an option'} first.`);
      if (sel) sel.focus();
      return;
    }
    drawerBusy = true;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-busy');
    setRowError(row, '');
    const box = scrollBox(); const top = box ? box.scrollTop : 0;
    const res = await addItems([{ id, rule: row.dataset.rule, title: row.dataset.title, productId: Number(row.dataset.productId) }], 'cart');
    if (!res.added.length) {
      drawerBusy = false;
      btn.disabled = false; btn.removeAttribute('aria-busy'); btn.classList.remove('is-busy');
      setRowError(row, res.error);
      return;
    }
    flash = { text: `Added to cart: ${names(res.added)}.`, top };
    const ok = await refreshDrawer(false);
    drawerBusy = false;
    if (!ok) window.location.reload();
  });

  function afterDrawerRender() {
    const d = drawerEl();
    if (!d) return;
    const mod = $('[data-tlm-offer="cart"]', d);
    if (flash) {
      const f = flash; flash = null;
      const box = scrollBox();
      if (box) box.scrollTop = f.top;
      const note = document.createElement('p');
      note.className = 'tlm-offer__flash';
      note.setAttribute('role', 'status');
      note.tabIndex = -1;
      note.textContent = f.text;
      const anchor = mod || $('.cart-drawer__details', d);
      if (anchor) {
        anchor.parentNode.insertBefore(note, anchor);
        note.focus({ preventScroll: true });
      }
      announce(f.text);
    }
    if (mod && drawerOpen()) seen(mod, 'cart');
  }

  // Visually hidden live region that survives drawer re-renders.
  let live = null;
  function announce(text) {
    if (!live) {
      live = document.createElement('div');
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(() => { live.textContent = text; }, 50);
  }

  /* ---------------- impressions ---------------- */
  const seenKeys = new Set();
  function seen(mod, placement) {
    const rows = $$('[data-offer-row]', mod).filter((r) => !r.hidden);
    const key = placement + rows.map((r) => r.dataset.productId).join(',');
    if (!rows.length || seenKeys.has(key)) return;
    const fire = () => {
      if (seenKeys.has(key)) return;
      seenKeys.add(key);
      publish('tlm_offer_viewed', { placement, anchor_product_id: Number(mod.dataset.anchorId) || null, items: rows.map(rowData) });
    };
    if (placement === 'cart' || !('IntersectionObserver' in window)) { fire(); return; }
    const io = new IntersectionObserver((ents) => { if (ents.some((x) => x.isIntersecting)) { io.disconnect(); fire(); } }, { threshold: 0.5 });
    io.observe(mod);
  }

  function boot() {
    $$('[data-tlm-offer="pdp"]').forEach(initPdp);
    const d = drawerEl();
    if (d) {
      new MutationObserver(() => afterDrawerRender()).observe(d, { childList: true });
      const ov = $('[data-cart-overlay]');
      if (ov) new MutationObserver(() => { const m = $('[data-tlm-offer="cart"]', d); if (m && drawerOpen()) seen(m, 'cart'); }).observe(ov, { attributes: true, attributeFilter: ['class'] });
    }
  }

  window.TLMOffers = { addItems, refreshDrawer, formatMoney };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
